import { ReactElement, ReactNode, MouseEvent } from 'react';
import { styled } from '@mui/material/styles';
import { ListItem, ListItemText, Button, Box } from '@mui/material';

const StyledListItem = styled(ListItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const ActionWrapper = styled(Box)(({ theme }) => ({
  '& button': {
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
}));

export type DangerZoneActionProps = {
  primaryText: string;
  secondaryText?: string;
  actionText?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => unknown;
  renderButton?: () => ReactNode;
};

export const DangerZoneAction = ({
  primaryText,
  secondaryText,
  actionText,
  onClick,
  renderButton,
}: DangerZoneActionProps): ReactElement => {
  return (
    <StyledListItem>
      <ListItemText primary={primaryText} secondary={secondaryText} sx={{ flex: 1 }} />
      {actionText && (onClick || renderButton) && (
        <ActionWrapper>
          {renderButton ? (
            renderButton()
          ) : (
            <Button variant="outlined" onClick={onClick}>
              {actionText}
            </Button>
          )}
        </ActionWrapper>
      )}
    </StyledListItem>
  );
};

export default DangerZoneAction;
